import { ACTION_RICH_MENU } from './actions'
import { IRichMenuRequest, IRichMenu } from '@/utils/types'
import { apiListChangedHandler } from '@/utils/helpers'
import richMenuApi from '@/api/richMenu'
import cloneDeep from 'lodash/cloneDeep'
import { localStore } from '@/utils/localstore'
import { constant } from '@/utils/constants'

type TState = {
  items: IRichMenu[]
  loading: boolean
}

export default {
  state: {
    items: [],
    loading: false,
  },
  getters: {
    richMenus: (state: TState) => {
      return state.items as IRichMenu[]
    },
  },
  mutations: {
    // [List]
    [ACTION_RICH_MENU.SET_ITEMS]: (state: TState, { items }: { items: IRichMenu[] }) => {
      state.items = cloneDeep(items) as IRichMenu[]
    },

    // [New item]
    [ACTION_RICH_MENU.SET_NEW_ITEM]: (state: TState, { item }: { item: IRichMenu }) => {
      state.items = apiListChangedHandler<IRichMenu>(state.items, cloneDeep(item), 'added')
    },

    // [UPDATE]]
    [ACTION_RICH_MENU.SET_UPDATED_ITEM]: (state: TState, { item }: { item: IRichMenu }) => {
      state.items = apiListChangedHandler<IRichMenu>(state.items, cloneDeep(item), 'modified')
    },

    // [Deleted item]
    [ACTION_RICH_MENU.SET_DELETED_ITEM]: (state: TState, { item }: { item: IRichMenu }) => {
      state.items = apiListChangedHandler<IRichMenu>(state.items, cloneDeep(item), 'removed')
    },
  },
  actions: {
    // eslint-disable-next-line
    [ACTION_RICH_MENU.LOAD_ITEMS]: async ({ commit }, params: IRichMenuRequest) => {
      const key = constant.LOCAL_KEYS.RICH_MENUS + params.app_id + JSON.stringify(params)
      let resp
      resp = localStore.getWithExpiry(key)
      if (!resp) {
        resp = await richMenuApi.list(params)
        localStore.setWithExpiry(key, resp, constant.LOCAL_EXPIRED)
      }
      commit(ACTION_RICH_MENU.SET_ITEMS, { items: resp })
      return resp
    },
    // eslint-disable-next-line
    [ACTION_RICH_MENU.LOAD_ITEM]: async ({ commit }, id: string) => {
      const resp = await richMenuApi.single(id)
      return resp
    },
    [ACTION_RICH_MENU.ADD]: async ({ commit }, payload: IRichMenu) => {
      const resp = await richMenuApi.add(payload)
      if (resp?._id) {
        localStore.removeStartsWith(constant.LOCAL_KEYS.RICH_MENUS + resp.app_id)
        commit(ACTION_RICH_MENU.SET_NEW_ITEM, { item: resp })
        return true
      }
    },
    [ACTION_RICH_MENU.UPDATE]: async ({ commit }, payload: IRichMenu) => {
      const resp = await richMenuApi.update(payload)
      if (resp?._id) {
        localStore.removeStartsWith(constant.LOCAL_KEYS.RICH_MENUS + resp.app_id)
        commit(ACTION_RICH_MENU.SET_UPDATED_ITEM, { item: resp })
        return true
      }
    },
    [ACTION_RICH_MENU.DELETE]: async ({ commit }, id: string) => {
      const resp = await richMenuApi.delete(id)
      if (resp?._id) {
        localStore.removeStartsWith(constant.LOCAL_KEYS.RICH_MENUS + resp.app_id)
        commit(ACTION_RICH_MENU.SET_DELETED_ITEM, { item: resp })
        return true
      }
    },
    // eslint-disable-next-line
    [ACTION_RICH_MENU.IS_ACTIVE]: async ({ commit }, payload: IRichMenu) => {
      const resp = await richMenuApi.active(payload)
      if (resp?._id) {
        localStore.removeStartsWith(constant.LOCAL_KEYS.RICH_MENUS + payload.app_id)
        commit(ACTION_RICH_MENU.SET_UPDATED_ITEM, { item: payload })
        return true
      }

      return false
    },

    [ACTION_RICH_MENU.TEST_MODE]: async ({ commit }, payload: IRichMenu) => {
      const resp = await richMenuApi.testMode(payload)
      if (resp?._id) {
        localStore.removeStartsWith(constant.LOCAL_KEYS.RICH_MENUS + payload.app_id)
        commit(ACTION_RICH_MENU.SET_UPDATED_ITEM, { item: payload })
        return true
      }

      return false
    },
  },
}
